import React from "react";
import LegalLayout from "../../components/LegalLayout";

const KVKK = () => {
  return (
    <LegalLayout title="Kişisel Verilerin Korunması Hakkında Aydınlatma Metni">

      <h2>1. Veri Sorumlusu</h2>

      <p>
        Bu Aydınlatma Metni, 6698 Sayılı Kişisel Verilerin Korunması Kanunu
        ("KVKK") kapsamında hazırlanmıştır.
      </p>

      <p>
        Kişisel verileriniz, veri sorumlusu sıfatıyla Goo More tarafından ilgili mevzuata uygun olarak işlenmektedir.
      </p>

      <br />

      <h2>2. İşlenen Kişisel Veriler</h2>

      <p>
        Sunulan hizmetlerin yerine getirilebilmesi amacıyla aşağıdaki kişisel
        veriler işlenebilmektedir:
      </p>

      <ul>
        <li>Ad ve Soyad</li>
        <li>Telefon Numarası</li>
        <li>E-posta Adresi</li>
        <li>Teslimat ve Fatura Adresi</li>
        <li>İl / İlçe Bilgisi</li>
        <li>Sipariş Bilgileri</li>
        <li>IP Adresi</li>
        <li>Tarayıcı ve Cihaz Bilgileri</li>
      </ul>

      <br />

      <h2>3. Kişisel Verilerin İşlenme Amaçları</h2>

      <p>
        Kişisel verileriniz aşağıdaki amaçlarla işlenmektedir:
      </p>

      <ul>
        <li>Siparişlerin oluşturulması ve yönetilmesi</li>
        <li>Ödeme işlemlerinin gerçekleştirilmesi</li>
        <li>Ürünlerin hazırlanması ve teslim edilmesi</li>
        <li>Fatura düzenlenmesi</li>
        <li>Müşteri destek hizmetlerinin sunulması</li>
        <li>İade ve değişim süreçlerinin yürütülmesi</li>
        <li>Yasal yükümlülüklerin yerine getirilmesi</li>
        <li>Bilgi güvenliğinin sağlanması</li>
      </ul>

      <br />

      <h2>4. Kişisel Verilerin Toplanma Yöntemi ve Hukuki Sebebi</h2>

      <p>
        Kişisel verileriniz; internet sitemiz, iletişim formu, sipariş ekranları,
        telefon, e-posta ve benzeri iletişim kanalları aracılığıyla elektronik
        ortamda toplanmaktadır.
      </p>

      <p>
        Verileriniz, KVKK'nın 5. ve 6. maddelerinde belirtilen hukuki sebepler
        kapsamında işlenmektedir.
      </p>

      <br />

      <h2>5. Ödeme Güvenliği</h2>

      <p>
        Tüm ödeme işlemleri, lisanslı ödeme kuruluşlarının SSL korumalı güvenli
        ödeme altyapısı üzerinden gerçekleştirilmektedir.
      </p>

      <br />

      <h2>6. Kişisel Verilerin Aktarılması</h2>

      <p>
        Kişisel verileriniz yalnızca hizmetin yerine getirilebilmesi amacıyla ve
        ilgili mevzuat kapsamında aşağıdaki kişi ve kuruluşlarla paylaşılabilir:
      </p>

      <ul>
        <li>Ödeme kuruluşları</li>
        <li>Kargo ve lojistik firmaları</li>
        <li>Mali müşavir ve muhasebe hizmet sağlayıcıları</li>
        <li>Yetkili kamu kurum ve kuruluşları</li>
      </ul>

      <br />

      <h2>7. KVKK Kapsamındaki Haklarınız</h2>

      <p>
        KVKK'nın 11. maddesi kapsamında aşağıdaki haklara sahipsiniz:
      </p>

      <ul>
        <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
        <li>İşlenmişse buna ilişkin bilgi talep etme</li>
        <li>Eksik veya yanlış işlenen verilerin düzeltilmesini isteme</li>
        <li>Kişisel verilerin silinmesini veya yok edilmesini talep etme</li>
        <li>İşleme faaliyetlerine itiraz etme</li>
        <li>Kanuna aykırı veri işlenmesi nedeniyle zarara uğramanız halinde tazminat talep etme</li>
      </ul>

      <br />

      <h2>8. Başvuru Yöntemi</h2>

      <p>
        KVKK kapsamındaki taleplerinizi yazılı olarak veya ilgili mevzuatta
        belirtilen diğer yöntemlerle tarafımıza iletebilirsiniz.
      </p>

      <br />

      <h2>9. İletişim</h2>

      <p>
        KVKK kapsamındaki tüm başvurularınız için aşağıdaki iletişim bilgilerimizi
        kullanabilirsiniz.
      </p>

      <ul>
        <li>
          <strong>Şirket:</strong> One Shop E-ticaret Kozmetik Ürünleri Ticaret LTD. ŞTİ.
        </li>

        <li>
          <strong>Adres:</strong> Genç Osman Mahallesi Pınar Sokak No:9
          Güngören / İstanbul
        </li>

        <li>
          <strong>Telefon:</strong> +90 537 210 14 52
        </li>

        <li>
          <strong>E-posta:</strong> goomoreinternational@gmail.com
        </li>

        <li>
          <strong>Vergi Dairesi:</strong> Esenler Vergi Dairesi
        </li>

        <li>
          <strong>Vergi No:</strong> 6430860629
        </li>
      </ul>

    </LegalLayout>
  );
};

export default KVKK;